export default "__VITE_ASSET__Bic2_oIz__"